module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.5f797490.ttf";